var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTelegram = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28746 7.83905C1.28746 7.83905 10.5753 3.88768 13.7965 2.49635C15.0312 1.93981 19.2188 0.15891 19.2188 0.15891C19.2188 0.15891 21.1515 -0.620235 20.9905 1.27197C20.9368 2.05112 20.5073 4.77813 20.0778 7.72775C19.4336 11.9017 18.7356 16.4653 18.7356 16.4653C18.7356 16.4653 18.6283 17.7453 17.7156 17.9679C16.8029 18.1906 15.2997 17.1888 15.0312 16.9662C14.8165 16.7992 11.0047 14.2948 9.60889 13.0705C9.23308 12.7365 8.80359 12.0687 9.66258 11.2896C11.5953 9.453 13.9038 7.17122 15.2997 5.72423C15.9439 5.05639 16.5882 3.4981 13.9038 5.39031C10.0921 8.11732 6.334 10.6774 6.334 10.6774C6.334 10.6774 5.47502 11.2339 3.86442 10.733C2.25382 10.2321 0.374783 9.56431 0.374783 9.56431C0.374783 9.56431 -0.913697 8.72951 1.28746 7.83905Z",
    fill: "#191919"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelegram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/telegram.6aa2bb0714816f4a76372b30af31ed2a.svg";